// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1nJvP","rightAdornment":"Header_rightAdornment__s4zQf"};